import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { UsuarioInativoComponent } from './usuario-inativo/usuario-inativo.component';
import { UsuarioSemModulosComponent } from './usuario-sem-modulos/usuario-sem-modulos.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'usuario-inativo', component: UsuarioInativoComponent },
  { path: 'usuario-sem-modulos', component: UsuarioSemModulosComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule
  ]
})
export class AuthenticationRoutingModule { }

